import { RootState } from 'editor/src/store/index';

const getClipboardElementUuid = (state: RootState) => state.editor.clipboardElementUuid;

export default getClipboardElementUuid;
